import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { AgmCoreModule } from '@agm/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TiendasComponent } from './tiendas/tiendas.component';
import { WayfindingComponent } from './wayfinding/wayfinding.component';
import { IndexComponent } from './index/index.component';
import { ServiciosComponent } from './servicios/servicios.component';
import { OfertasComponent } from './ofertas/ofertas.component';
import { TiendaSelecComponent } from './tienda-selec/tienda-selec.component';
import { EventosComponent } from './eventos/eventos.component';
import { EventoSelComponent } from './evento-sel/evento-sel.component';
import { TestkeyboardComponent } from './testkeyboard/testkeyboard.component';
import { DragScrollModule } from 'ngx-drag-scroll';
import { BuscarComponent } from './buscar/buscar.component';
import { InformacionComponent } from './informacion/informacion.component';
import { CineComponent } from './cine/cine.component';
import { EmbedVideo } from 'ngx-embed-video';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { PeliculaComponent } from './pelicula/pelicula.component';
import { EstacionamientosComponent } from './estacionamientos/estacionamientos.component';
import { EnviarrutaComponent } from './enviarruta/enviarruta.component';
import { ZonasinteresComponent } from './zonasinteres/zonasinteres.component';
import { GoogleAnalyticsService } from './google-analytics.service';
import { ZonagourmetComponent } from './zonagourmet/zonagourmet.component';
import { PatiodecomidaComponent } from './patiodecomida/patiodecomida.component';
import { NgxQRCodeModule } from 'ngx-qrcode2';
import { QRCodeModule } from 'angularx-qrcode';
import { NgHighlightModule } from 'ngx-text-highlight';
import { MenulteralComponent } from './menulteral/menulteral.component';
import { MenudownComponent } from './menudown/menudown.component';

 
const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto'
};



@NgModule({
  declarations: [
    AppComponent,
    TiendasComponent,
    WayfindingComponent,
    IndexComponent,
    ServiciosComponent,
    OfertasComponent,
    TiendaSelecComponent,
    EventosComponent,
    EventoSelComponent,
    TestkeyboardComponent,
    BuscarComponent,
    InformacionComponent,
    CineComponent,
    PeliculaComponent,
    EstacionamientosComponent,
    EnviarrutaComponent,
    ZonasinteresComponent,
    ZonagourmetComponent,
    PatiodecomidaComponent,
    MenulteralComponent,
    MenudownComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    DragScrollModule,
    SwiperModule,
    QRCodeModule,
    BrowserAnimationsModule,
    EmbedVideo.forRoot(),
    NgxQRCodeModule,
    NgHighlightModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCCLr-gdG0_e8UvyKwHdEHI_I9WxgVQ-ZA'
    }),
  ],
  providers: [
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG
    },
    GoogleAnalyticsService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
